import { createContext, useContext, ReactNode } from 'react';

interface TabContextType {
  activeTab: string;
  setActiveTab: (tabId: string) => void;
}

const TabContext = createContext<TabContextType | undefined>(undefined);

export function TabProvider({
  children,
  activeTab,
  setActiveTab,
}: {
  children: ReactNode;
  activeTab: string;
  setActiveTab: (tabId: string) => void;
}) {
  return (
    <TabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </TabContext.Provider>
  );
}

export function useTab() {
  const context = useContext(TabContext);
  if (context === undefined) {
    throw new Error('useTab must be used within a TabProvider');
  }
  return context;
}


/** For components also rendered outside the app shell (tests, previews): undefined there instead of throwing. */
export function useOptionalTab() {
  return useContext(TabContext);
}
